import { render, staticRenderFns } from "./addcustemdialog.vue?vue&type=template&id=8d8a48dc&scoped=true"
import script from "./addcustemdialog.vue?vue&type=script&lang=js"
export * from "./addcustemdialog.vue?vue&type=script&lang=js"
import style0 from "./addcustemdialog.vue?vue&type=style&index=0&id=8d8a48dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8a48dc",
  null
  
)

export default component.exports